import { get } from "lodash-es";
import { useEffect, useState } from "react";

import { useSelector } from "../store";
import { hasPermission } from "../utils/permissions";

type UseReadOnlyProps = {
  clusterId: string | undefined;
  organizationId: string | undefined;
};

function useReadOnly({ clusterId, organizationId }: UseReadOnlyProps) {
  const { byId } = useSelector((state) => state.namespaces);
  const [readonly, setReadonly] = useState<boolean>(true);
  const { byId: orgById } = useSelector((state) => state.organizations);
  const orgReadOnly = get(
    orgById,
    organizationId + ".readOnly",
    false,
  ) as boolean;

  useEffect(() => {
    setReadonly(
      orgReadOnly ||
        !hasPermission(
          get(byId, clusterId + ".namespace.role", "") as string,
          "manager",
        ),
    );
  }, [orgReadOnly, clusterId, JSON.stringify(byId)]);
  return readonly;
}
export default useReadOnly;
